// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"538":"recorder","983":"profiler"}[chunkId] + "-" + {"538":"f5d9d79c73b38181d9e8","983":"cbdbb58d11e2972027be"}[chunkId] + ".chunk.js";
};